export default __webpack_public_path__ + "static/media/suitable.b3bdfff2.svg";